import { graphql } from '@shared/types/customer'

export const customerQuery = graphql(`
  query Customer {
    customer {
      ...CustomerFragment
    }
  }
`)

export const customerFragment = graphql(`
  fragment CustomerFragment on Customer {
    id
    emailAddress {
      emailAddress
    }
    cartId: metafield(namespace: "custom", key: "cart_id") {
      id
      key
      value
      type
    }
    firstName
    lastName
    creationDate
    phoneNumber {
      phoneNumber
    }
    addresses(first: 20) {
      items: nodes {
        ...CustomerAddress
      }
    }
  }
`)

export const customerAddressFragment = graphql(`
  fragment CustomerAddress on CustomerAddress {
    id
    address1
    address2
    city
    country
    firstName
    lastName
    formatted(withName: true)
    formattedArea
    name
    phoneNumber
    province
    zip
    territoryCode
  }
`)

export const setCustomerCartIdQuery = graphql(`
  mutation setCartId($metafields: [MetafieldsSetInput!]!) {
    metafieldsSet(metafields: $metafields) {
      metafields {
        key
        namespace
        value
        createdAt
        updatedAt
      }
      userErrors {
        field
        message
        code
      }
    }
  }
`)
